import styled from 'styled-components';
import { Form } from '@thinknet-gmbh/platform-common-ui';

export const DocumentImportLabel = styled.div`
  display: flex;
  gap: 4px;
`;

export const LabelInfo = styled.div`
  cursor: pointer;
`;

export const StyledForm = styled(Form)`
  .upload-file-field {
    width: 100%;
    max-width: 100%;
     button {
       width: 100%;
       display: flex;
       justify-content: center;
       min-height: 32px;
     }
  }
`;
